import axios from './index';

import type { ApiResponse } from './dramas';

/** 真实列表字段（OpenAPI data 未细化） */
export interface UserStory {
    id: string;
    activity_id?: string;
    user_id?: string;
    content?: string | null;
    image_url?: string | null;
    /** 0 待审 / 1 已通过（以真实 JSON 为准） */
    status?: number | string | null;
    create_at?: string | null;
    audit_remark?: string | null;
    audit_at?: string | null;
}

export interface UserStoryListParams {
    page?: number | string;
    size?: number | string;
}

export const userStoryList = (params?: UserStoryListParams) =>
    axios<ApiResponse<UserStory[]>>('/v1/user-stories', {
        method: 'get',
        params,
    });
